import { Link } from 'react-router-dom';
import IMAGES from '../images';
import './CertificatPage.css';

export default function CertificatPage() {
  return (
    <main className="cpage certificat-page">
      {/* Universal Banner */}
      <div className="cpage__banner">
        <img src={IMAGES.garantie[0]} alt="Garantie & Authenticité" className="cpage__banner-img" />
        <div className="cpage__banner-overlay" />
        <div className="cpage__banner-content">
          <span className="section-label">Garantie & Qualité</span>
          <h1 className="cpage__banner-title">Certificat d'Authenticité</h1>
          <div className="cpage__banner-divider" />
          <p className="cpage__banner-desc">
            Chaque création Khansa Yazidi est une pièce unique forgée pour traverser les époques.
          </p>
        </div>
      </div>

      <div className="certificat-page__content">
        <div className="certificat-page__text-block">
          <p>
            L'excellence de Khansa Yazidi repose sur une sélection rigoureuse de matériaux nobles 
            et un savoir-faire artisanal hérité de générations de maîtres artisans tunisiens. 
            Chaque pièce qui quitte nos ateliers est unique et porte en elle la trace de la main qui l'a façonnée.
          </p>
          <p>
            Pour garantir cette qualité exceptionnelle, toutes nos créations sont accompagnées 
            d'un <strong>Certificat d'Authenticité et de Garantie</strong>.
          </p>
        </div>

        <div className="certificat-page__gallery">
          {IMAGES.garantie.map((img, i) => (
            <div key={i} className="certificat-page__img-wrap">
              <img src={img} alt={`Certificat de garantie ${i + 1}`} />
            </div>
          ))}
        </div>

        <div className="certificat-page__details">
          <h2>Notre Engagement</h2>
          <ul>
            <li><strong>Laiton Massif</strong> : Résistance absolue à la corrosion et durabilité exceptionnelle, Garantie sans plomb.</li>
            <li><strong>Marbre Naturel</strong> : Des veines uniques pour chaque vasque, soigneusement sélectionnées.</li>
            <li><strong>Savoir-faire Artisanal</strong> : Aucun procédé industriel. Un façonnage manuel garantissant des finitions parfaites.</li>
            <li><strong>Garantie</strong> : Une garantie de 5 ans sur toutes notre robinetterie.</li>
          </ul>
        </div>
        
        <div className="certificat-page__cta">
          <p>Une question sur l'entretien de vos pièces ?</p>
          <Link to="/contact" className="btn-outline">Contactez-Nous</Link>
        </div>
      </div>
    </main>
  );
}
